import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const TimeSlotsQuery = graphql(/* GraphQL */ `
  query timeSlots($timeSlotsInput: GetTimeSlotsInput!) {
    timeSlots(input: $timeSlotsInput) {
      ...TimeSlot
    }
  }
`);
